import { createSelector } from '@reduxjs/toolkit'
import { selectModifiedLicenseUpdates } from './selectModifiedLicenseUpdates'
import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'
import { ILicenseUpdate } from '../types/LicenseUpdate'

export const selectPaginatedItems = createSelector(
	[
		selectModifiedLicenseUpdates,
		(store: StoreSchema) => store.licenseUpdates.paginatedLicenseUpdates.currentPage,
		(store: StoreSchema) => store.licenseUpdates.limit,
		(store: StoreSchema) => store.licenseUpdates.sort.sort,
		(store: StoreSchema) => store.licenseUpdates.sort.direction
	],
	(items, currentPage, limit, sort, direction) => {
		let sorted = [...items] as ILicenseUpdate[]

		if (sort && direction) {
			sorted.sort((a, b) => {
				const aVal = a[sort as keyof ILicenseUpdate] as string
				const bVal = b[sort as keyof ILicenseUpdate] as string

				if (aVal < bVal) return direction === 'ascending' ? -1 : 1
				if (aVal > bVal) return direction === 'ascending' ? 1 : -1
				return 0
			})
		}

		const start = (currentPage - 1) * limit
		const end = start + limit

		return sorted.slice(start, end)
	}
)